<template xmlns="http://www.w3.org/1999/html">
  <div style="width: 100vw;height: 100vh;background-color: white;">
    <img src="/static/images/kuaima/logo.png" style="width: 60vw;position: absolute;top: 8vh;left: 20vw;" />


    <div v-if="isQuery"
      style="width: 100vw;position: absolute;top: 20vh;display: flex;flex-direction: column;align-items: center;justify-content: center;">
      <input v-model="antiCode" @input="handleInput" type="text" maxlength="19"
        style="width: 80%;height: 5.5vh;border:1px solid;border-radius: 4px;text-align: center;" placeholder="请输入防伪码" />
      <div
        style="width: 80%;height: 5.5vh;border:1px solid;border-radius: 4px;background-color: rgb(201, 23, 28);margin-top: 2vh;color: white;letter-spacing: 1vw;display: flex;align-items: center;justify-content: center;font-size: 4.5vw;"
        @click="queryAnti">查询真伪</div>
      <div
        style="width: 80%;height: 5.5vh;border:1px solid;border-radius: 4px;background-color: rgb(201, 23, 28);margin-top: 2vh;color: white;letter-spacing: 1vw;display: flex;align-items: center;justify-content: center;font-size: 4.5vw;"
        @click="toScan">扫描二维码</div>
    </div>

    <div v-if="showFirstQuery"
      style="width: 90vw;height: 28vh;position: absolute;top:18vh;left: 5vw;
     background-color: rgb(243, 243, 243);border-radius: 10px;
     box-shadow: 1.5px 1.5px 1.5px rgba(0, 0, 0, 0.3);display: flex;align-items: center;justify-content: center;flex-direction: column;">
      <div style="font-size: 3.5vw;color: rgb(89, 87, 87);">尊敬的用户</div>
      <div style="font-size: 3.5vw;color: rgb(89, 87, 87);margin-top: 1vh;">您查询的数码为：{{queryResultCode}}</div>

      <img src="/static/images/kuaima/line.png" style="width: 80%;margin-top: 3vh;margin-bottom: 3vh;" />

      <div style="font-size: 3.5vw;color: rgb(89, 87, 87);">感谢您购买长沙快马工服信息科技有限公司出品的</div>
      <div style="font-weight: bold;font-size: 3.5vw;color: rgb(89, 87, 87);color: rgb(203, 19, 28);margin-top: 1vh;">正宗 久驰•润滑油 产品</div>
      <div style="font-size: 3.5vw;color: rgb(89, 87, 87);margin-top: 1vh;">谢谢您的使用！</div>
    </div>


    <div v-if="showRepeatQuery"
      style="width: 90vw;height: 28vh;position: absolute;top:18vh;left: 5vw;
     background-color: rgb(243, 243, 243);border-radius: 10px;
     box-shadow: 1.5px 1.5px 1.5px rgba(0, 0, 0, 0.3);display: flex;align-items: center;justify-content: center;flex-direction: column;">
      <div style="font-size: 3.5vw;color: rgb(89, 87, 87);">尊敬的用户</div>
      <div style="font-size: 3.5vw;color: rgb(89, 87, 87);margin-top: 1vh;">您查询的数码为：{{queryResultCode}}</div>

      <img src="/static/images/kuaima/line.png" style="width: 80%;margin-top: 3vh;margin-bottom: 3vh;" />

      <div style="font-size: 3.5vw;color: rgb(89, 87, 87);">您所查询的数码已于{{ firstQueryTime }}</div>
      <div style="font-size: 3.5vw;color: rgb(89, 87, 87);margin-top: 1vh;">被首次查询过，此数码已失效</div>
      <div style="font-weight: bold;font-size: 3.5vw;color: rgb(89, 87, 87);color: rgb(203, 19, 28);margin-top: 1vh;">谨防假冒！</div>
      
    </div>

    <div v-if="showAntiFalse"
      style="width: 90vw;height: 28vh;position: absolute;top:18vh;left: 5vw;
     background-color: rgb(243, 243, 243);border-radius: 10px;
     box-shadow: 1.5px 1.5px 1.5px rgba(0, 0, 0, 0.3);display: flex;align-items: center;justify-content: center;flex-direction: column;">
      <div style="font-size: 3.5vw;color: rgb(89, 87, 87);">尊敬的用户</div>
      <div style="font-size: 3.5vw;color: rgb(89, 87, 87);margin-top: 1vh;">您查询的数码为：{{queryResultCode}}</div>

      <img src="/static/images/kuaima/line.png" style="width: 80%;margin-top: 3vh;margin-bottom: 3vh;" />

      <div style="font-size: 3.5vw;color: rgb(89, 87, 87);">所查询的码不存在</div>
      <div style="font-weight: bold;font-size: 3.5vw;color: rgb(89, 87, 87);color: rgb(203, 19, 28);margin-top: 1vh;">谨防假冒！</div>
      
    </div>


    <img src="/static/images/kuaima/you.png" style="width: 80vw;position: absolute;bottom: 14vh;left: 10vw;" />

    <div
      style="position: absolute;bottom: 0;width: 100vw;height: 8vh;color:white;background-color:rgb(202, 26, 29);display: flex;align-items: center;justify-content: center;">
      <span style="font-size: 4vw;">——</span>
      <span style="letter-spacing: 1vw;font-size: 4vw;">久驰•做更适合工程机械的好油</span>
      <span style="font-size: 4vw;">——</span>
    </div>


    <div v-show="isShow">
      <div id="fixedBg"></div>
      <p class="loading_p" id="loadP">
        <img src="/static/images/loadding.gif" />
      </p>
    </div>

  </div>
</template>

<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>

<script>
import { getAntiData, getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'
import moment from 'moment'
export default {
  data() {
    return {
      antiCode: "",
      isQuery: true,
      isShow: false,
      queryResultCode:"",
      eno: "138893318034",
      firstQueryTime: "",
      showFirstQuery: false,
      showRepeatQuery: false,
      showAntiFalse: false,
    }
  },
  methods: {
    handleInput() {
      this.antiCode = this.antiCode.replace(/(\w{4})(?=\w)/g, '$1 ');
    },
    toScan() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : '';
          }
          this.antiCode = scanQRCode.substring(0, 16)
          this.queryAnti()
        }
      });
    },
    queryAnti() {
      const code = this.antiCode.replace(/ /g, '');
      if (code.length != 16) {
        alert("请输入正确的16位防伪码");
        return;
      }
      this.isShow = true
      this.queryResultCode=code
      getAntiData(code, this.eno).then(res => {
        this.isShow = false
        const data = res.data;
        if (data == null || data.code == "500") {
          alert("防伪查询失败,请联系管理员");
        } else if (data.code == "300106") {
          this.isQuery=false
          this.showAntiFalse=true
        } 
        else if (data.code == "300101") {
          this.isQuery=false
          this.showFirstQuery=true
        } 
        else if (data.code == "300102") {
          this.firstQueryTime=moment(data.data.firstQueryTime).format('YYYY年MM月DD日HH时mm分ss秒')
          this.isQuery=false
          this.showRepeatQuery=true
        } 
      }).catch(err => {
        this.isShow = false
        console.log(err)
        alert("查询异常，请联系管理员")
      })

    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wxbc22565b3e7a59fd").then(res => {
        console.log(res)
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  created: function () {
    this.getWxJs()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/KuaiMa/Query.vue